/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ImplantOrderItem from './implant-order-item';
import ImplantOrderItemDetail from './implant-order-item-detail';
import ImplantOrderItemUpdate from './implant-order-item-update';
import ImplantOrderItemDeleteDialog from './implant-order-item-delete-dialog';

const ImplantOrderItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ImplantOrderItem />} />
    <Route path="new" element={<ImplantOrderItemUpdate />} />
    <Route path=":id">
      <Route index element={<ImplantOrderItemDetail />} />
      <Route path="edit" element={<ImplantOrderItemUpdate />} />
      <Route path="delete" element={<ImplantOrderItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ImplantOrderItemRoutes;
